import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConsultTypeService {

  private typeSource = new BehaviorSubject<string | null>(null);
  type$ = this.typeSource.asObservable();

  constructor(private translate: TranslateService) {}

  getTipologia(consultType: string): string {
    return this.translate.instant(`consult.${consultType}.tipologia`) || consultType;
  }
  
  getPrestazione(consultType: string): string {
    return this.translate.instant(`consult.${consultType}.prestazione`) || consultType;
  }

  setType(type: string) {
   this.typeSource.next(type);
 }
}
